module.exports = __webpack_public_path__ + "static/media/VesselOwn.f4f950aa.png";